module.exports = __webpack_public_path__ + "5941f521d66acc2b5c240ab151d149ad.svg";